<template>
  <div v-if="!isLoading && list.length">
    <div style="display: flex; gap: 2rem; max-width: 490px; margin-top: 1rem;">
      <QualificationSelect
        style="max-width: 235px;"
        v-model="qualificationTypeInBatch"
      />
      <b-overlay
        :show="busy"
        rounded
        opacity="0.6"
        spinner-small
        spinner-variant="secondary"
        class="d-inline-block"
      >
        <b-button
          :disabled="!selectedLeads.length || !this.qualificationTypeInBatch"
          @click="setQualificationTypeInBatch"
          style="width: 100%;"
        >
          Atualizar em lote
        </b-button>
      </b-overlay>
    </div>
    <div class="d-flex justify-content-between flex-column">
      <Table style="margin-top: 1rem;" class="leads-table">
        <TableHeader>
          <TableRow>
            <TableHead
              v-for="(leadsCol, index) in leadsColumns"
              :key="`${leadsCol}-${index}`"
            >
              <ColumnHeader
                :sort="leadsCol.sort"
                :somatory="leadsCol.somatory"
                :columnName="leadsCol.name"
                :columnKey="leadsCol.key"
                :columnType="leadsCol.columnType"
                :currentColumnFiltered="currentColumnFiltered"
                :sortDirection="sortDirection"
                :dataList="list"
                @sortListByKey="sortListByKey(leadsCol.key)"
              />
            </TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          <TableRow v-for="(item, idx) in list" :key="`${item}-${idx}`">
            <TableCell style="min-width: 50px;">
              <b-form-checkbox
                size="sm"
                @change="value => setLeadInBatch(value, item)"
              />
            </TableCell>
            <TableCell style="min-width: 45px;">{{ idx + 1 }}</TableCell>
            <TableCell style="min-width: 305px;"><RenderNameColumnValue :name="item.name" /></TableCell>
            <TableCell><RenderNameColumnValue :name="item.primaryCNAECode + '-' + item.primaryCNAEDescription" /></TableCell>
            <TableCell>{{ item.state }}</TableCell>
            <TableCell><RenderNameColumnValue :name="item.cityCode + '-' + item.cityDescription" /></TableCell>
            <TableCell>
              <div style="display: flex; justify-content: space-between; align-items: center; width: 200px;">
                <RenderSocialNumberColumnValue :social-number="item.socialNumber" />
                <b-button
                  variant="outline-primary"
                  size="sm"
                  @click="copySocialNumber(item.socialNumber)"
                >
                  <b-icon-clipboard></b-icon-clipboard>
                </b-button>
              </div>
            </TableCell>
            <TableCell>
              <RenderDateColumnValue :value="item.creationDate" />
            </TableCell>
            <TableCell>
              <b-overlay
                :show="busy"
                rounded
                opacity="0.6"
                spinner-small
                spinner-variant="secondary"
                class="d-inline-block"
              >
                <QualificationSelect
                  v-model="item.qualificationType"
                  @input="changeQualificationType(item)"
                />
              </b-overlay>
            </TableCell>
            <TableCell>
              <div style="display: flex; gap: 0.2rem;">
                <b-overlay
                  :show="busyButton"
                  rounded
                  opacity="0.6"
                  spinner-small
                  spinner-variant="outline-primary"
                  class="d-inline-block"
                >
                  <BaseButtonComponent
                    style="padding: 1px 12px;"
                    @click="recordObservation(item)"
                    variant="tertiary-action"
                  >
                    Gravar
                  </BaseButtonComponent>
                </b-overlay>
                <b-form-textarea
                  id="textarea"
                  debounce="1000"
                  v-model="item.observation"
                  placeholder="Observação"
                  rows="3"
                  max-rows="6"
                  style="border-radius: 4px; outline: none; border: 1px solid grey; width: 200px; height: 30px;"
                />
              </div>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </div>
  </div>
</template>

<script>
import {
  RenderSocialNumberColumnValue,
  RenderDateColumnValue,
  RenderNameColumnValue,
} from '../../../../ui/render';
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from '../../../../ui/table';
import { QualificationSelect } from '../index.js';
import { defineArrowDirection, sortByProperty } from '../../../../utils';
import { ColumnHeader } from '../../../../ui/column-header';
import { Api } from '../../../../vue/api';
import { BaseButtonComponent } from '../../../../ui/buttons';
const API = new Api();

export default {
  components: {
    Table,
    TableRow,
    TableBody,
    TableCell,
    TableHead,
    TableHeader,
    ColumnHeader,
    QualificationSelect,
    RenderNameColumnValue,
    RenderDateColumnValue,
    RenderSocialNumberColumnValue,
    BaseButtonComponent,
  },
  props: {
    list: {
      type: Array,
      default: () => [],
      required: true,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      qualificationTypeInBatch: null,
      selectedLeads: [],
      leadsColumns: [
        { name: '#', key: '', sort: false, somatory: false },
        { name: 'Nº', key: '', sort: false, somatory: false },
        { name: 'Razão Social', key: 'name', sort: true, somatory: false },
        { name: 'CNAE Primário', key: 'primaryCNAE', sort: true, somatory: false },
        { name: 'UF', key: 'state', sort: true, somatory: false },
        { name: 'Município', key: 'city', sort: true, somatory: false },
        { name: 'CNPJ', key: 'socialNumber', sort: false, somatory: false },
        { name: 'Data feita', key: 'creationDate', sort: true, somatory: false },
        { name: 'Qualificação', key: 'qualificationType', sort: true, somatory: false },
        { name: 'Observações', key: 'observation', sort: false, somatory: false },
      ],
      currentColumnFiltered: '',
      sortDirection: 'ASC',
      busyButton: false,
      busy: false,
    };
  },
  methods: {
    showToast(message, title = 'Aviso', variant = 'info') {
      this.$bvToast.toast(message, { title, variant, solid: true });
    },
    copySocialNumber(socialNumber) {
      if (!socialNumber) {
        this.showToast('Não há número para copiar.', 'Aviso', 'warning');
        return;
      }
      navigator.clipboard
        .writeText(socialNumber)
        .then(() => {
          this.showToast('Número copiado com sucesso!', 'Sucesso', 'success');
        })
        .catch((err) => {
          this.showToast(`Erro ao copiar número: ${err.message}`, 'Erro', 'danger');
        });
    },
    sortListByKey(columnKey) {
      this.sortDirection = defineArrowDirection(
        this.currentColumnFiltered,
        columnKey,
        this.sortDirection
      );
      this.currentColumnFiltered = columnKey;
      sortByProperty(this.list, columnKey, this.sortDirection);
    },
    setLeadInBatch(checked, lead) {
      if (!checked) {
        this.selectedLeads = this.selectedLeads.filter(item => item !== lead);
      } else if (!this.selectedLeads.includes(lead)) {
        this.selectedLeads.push(lead);
      }
    },
    async changeQualificationType(item) {
      await this.setQualificationType([item], item.qualificationType);
    },
    async recordObservation(lead) {
      if (!lead.id) {
        this.showToast('Lead precisa ser qualificado antes de gravar observação', 'Erro', 'danger');
        return;
      }
      if (!lead.observation) {
        this.showToast('Observação não pode ser vazia', 'Erro', 'danger');
        return;
      }
      try {
        this.busyButton = true;
        const { ok, errors } = await API.post('/execute', {
          path: `/lead-management/observation/${lead.id}`,
          method: 'post',
          data: { observation: lead.observation },
        });
        if (!ok) {
          throw new Error((errors && errors.message) || 'Não foi possível adicionar a observação ao lead');
        }
        this.showToast('Observação incluída com sucesso!', 'Sucesso', 'success');
      } catch (error) {
        this.showToast(error.message, 'Erro', 'danger');
      } finally {
        this.busyButton = false;
      }
    },
    async setQualificationTypeInBatch() {
      await this.setQualificationType(this.selectedLeads, this.qualificationTypeInBatch);
    },
    async setQualificationType(leadsList, qualificationType) {
      this.busy = true;
      try {
        const { model, ok, errors } = await API.post('/execute', {
          path: `/lead-management/set-qualification`,
          method: 'post',
          data: {
            leadsList,
            qualificationType,
          },
        });
        if (!ok) {
         throw new Error((errors && errors.message) || 'Erro ao atualizar qualificação do lead');
        }
        this.updateLeadsOfTable(model);
        this.showToast('Tipo de qualificação atualizado com sucesso!', 'Sucesso', 'success');
      } catch (error) {
        this.showToast(error.message, 'Erro', 'danger');
      } finally {
        this.busy = false;
      }
    },
    updateLeadsOfTable(qualifiedLeads) {
      qualifiedLeads.forEach(qualifiedLead => {
        const leadFound = this.list.find(
          lead => lead.socialNumber === qualifiedLead.social_number
        );
        if (leadFound) {
          this.$set(leadFound, 'id', qualifiedLead.id);
          this.$set(leadFound, 'qualificationType', qualifiedLead.qualification_type);
          this.$set(leadFound, 'creationDate', qualifiedLead.created_at);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.leads-table {
  display: block;
  max-height: 48vh !important;
  height: auto !important;

  th:first-child,
  td:first-child {
    z-index: 2;
    position: sticky;
    left: 0;
    background-color: #e7e7e7;
  }

  td:nth-child(2),
  th:nth-child(2) {
    z-index: 2;
    position: sticky;
    left: 2.75rem;
    background-color: #e7e7e7;
  }

  td:nth-child(3),
  th:nth-child(3) {
    z-index: 2;
    position: sticky;
    left: 5.5rem;
    background-color: #e7e7e7;
  }
  td:nth-child(4),
  th:nth-child(4) {
    z-index: 2;
    position: sticky;
    left: 7rem;
    background-color: #e7e7e7;
  }

  td:nth-child(5),
  th:nth-child(5),
  td:nth-child(6),
  th:nth-child(6),
  td:nth-child(7),
  th:nth-child(7),
  td:nth-child(8),
  th:nth-child(8) {
    background-color: #e7e7e7;
  }

  tr:nth-child(odd) td:nth-child(-n + 8) {
    background-color: #e7e7e7;
  }
  tr:nth-child(even) td:nth-child(-n + 8) {
    background-color: #f2f2f2;
  }
}
</style>